import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UsuarioModelResponse, FuncaoRequest, ModuloUsuarioResponse, FuncaoModuloResponse } from 'common/genericTypes';

export const PostModulosLimite = async (dispatch: Dispatch, payload: FuncaoRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<FuncaoModuloResponse[]>(`${requestConfig.api}api/v1/modulos/funcao`, payload),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETModulosUsuario = async (dispatch: Dispatch, usuarioId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<FuncaoModuloResponse[]>(`${requestConfig.api}api/v1/modulos/usuario/${usuarioId}`),
    dispatch,
    undefined,
    stackRequest
  );
};
